import React from 'react';
import { Link } from 'react-router-dom';

const EmptyState: React.FC = () => {
  return (
    <div style={{ paddingTop: 60 }}>
      <div style={{ textAlign: 'center' }}>
        <img
          src="/icons/empty-states/incident.svg"
          alt="incident"
          style={{ display: 'inline-block', width: 150 }}
        />
        <p className="empty-state-headline">No incidents found!</p>
        <Link to="/incident/create">
          <button className="main-button" style={{ marginTop: 30, marginBottom: 50 }}>
            Create Incident
          </button>
        </Link>
      </div>
    </div>
  );
};

export default EmptyState;
